 
export enum NmvsProvider {
  Unknown = 0,
  Solidsoft = 1,
  Arvato = 2,
  SecurPharm = 3
}


// WEBPACK FOOTER //
// ./src/types/nmvs-provider.ts